import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { TRoutes } from '../../shared/const'

import styles from './style.module.scss'

/**
 * Erklaerung zur Einwilligung der Unterstuetzer:innen.
 *
 * Die Verarbeitung ihrer Daten beruht - anders als bei Schueler:innen und
 * Lehrkraeften - auf einer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Damit sie
 * wirksam ist, muss vor dem Haken stehen, worin eingewilligt wird: welche Daten
 * fuer Schulen sichtbar werden, welche verborgen bleiben und dass der Widerruf
 * jederzeit im Profil moeglich ist (Anforderung #59, von JAA am 20.08.2026
 * freigegeben).
 *
 * Steht an drei Stellen: Selbstregistrierung, Aktivierung einer Einladung und
 * im Profil - dort als Beleg dessen, worin einmal eingewilligt wurde.
 */
export default function GdprConsentNote({ className }) {
	const { t } = useTranslation()

	return (
		<p className={clsx(styles.note, className)}>
			{t('gdprConsentDetails')}{' '}
			<a className={styles.link} href={TRoutes.DATENSCHUTZ} target="_blank" rel="noreferrer">
				{t('Privacy policy')}
			</a>
		</p>
	)
}

GdprConsentNote.propTypes = {
	className: PropTypes.string
}
